import React from "react";

function LoadingSpinner({ size = "medium" }) {
  const sizeClasses = {
    small: "h-4 w-4",
    medium: "h-8 w-8",
    large: "h-24 w-24",
  };

  // Simplified ES logo path

  const pathData = `
    M163.002 163.35 L163.002 244.968 L240.369 244.968 L240.369 163.35 L163.002 163.35 Z
    M163.002 286.141 L163.002 367.759 L240.369 367.759 L240.369 286.141 L163.002 286.141 Z
    M239.587 122.591 L239.587 163.452 L271.84 163.452 L273.085 163.452 L357.192 163.452 L357.192 161.586
      C356.133 139.883 337.103 122.591 313.22 122.591 L273.085 122.591 L271.84 122.591 L239.587 122.591 Z
    M271.84 244.967 L271.84 245.071 L239.587 245.071 L239.587 286.243 L273.085 286.243 L273.085 286.14
      L313.22 286.14 L313.22 367.758 L273.085 367.758 L271.84 367.758 L239.587 367.758
      L239.587 408.619 L271.84 408.619 L273.085 408.619 L313.22 408.619
      C337.103 408.619 356.132 391.224 357.192 369.521 L357.192 284.065
      C356.11 262.382 337.088 244.967 313.22 244.967 L271.84 244.967 Z
  `;

  return (
    <div className="flex items-center justify-center">
      <svg
        className={`${sizeClasses[size]}`}
        viewBox="-3.2 -3.2 514 514"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          {/* Lighter gray gradient top to bottom */}
          <linearGradient id="fadeGradient" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="rgba(180,180,180,0.7)" />
            <stop offset="100%" stopColor="rgba(180,180,180,0)" />
            <animateTransform
              attributeName="gradientTransform"
              type="translate"
              from="0 -1"
              to="0 1"
              dur="4s"
              repeatCount="indefinite"
            />
          </linearGradient>

          <filter id="glassEffect">
            <feGaussianBlur in="SourceGraphic" stdDeviation="1.5" result="blur" />
            <feColorMatrix
              in="blur"
              type="matrix"
              values="
                1 0 0 0 0
                0 1 0 0 0
                0 0 1 0 0
                0 0 0 0.6 0"
              result="coloredBlur"
            />
            <feBlend in="SourceGraphic" in2="coloredBlur" mode="lighten" />
          </filter>
        </defs>

        <g transform="translate(-58.3 -64.9) scale(1.2)">
          <path
            d={pathData}
            stroke="url(#fadeGradient)"
            strokeWidth="9.07161"
            strokeLinecap="round"
            strokeLinejoin="round"
            filter="url(#glassEffect)"
          />
        </g>

        <style>
          {`
            svg path {
              stroke-dasharray: 2000;
              stroke-dashoffset: 2000;
              animation: dash 4s ease-in-out infinite;
            }

            @keyframes dash {
              0% {
                stroke-dashoffset: 2000;
              }
              50% {
                stroke-dashoffset: 0;
              }
              100% {
                stroke-dashoffset: -2000;
              }
            }
          `}
        </style>
      </svg>
    </div>
  );
}

export default LoadingSpinner;
